<ng-container *ngIf="contribution !== 'transfer_only'">
  <div class="white-box title-box">
    <h4>{{ 'steps.id5.account_to_fund.deposit_box.title' | translate }}</h4>
  </div>
  <div class="white-box section-details">
    <p class="description">{{ 'steps.id5.account_to_fund.deposit_box.note' | translate }}</p>
  </div>
</ng-container>

<div>
  <div class="white-box title-box">
    <h4>{{ 'steps.id5.account_to_fund.transfer_box.title' | translate }}</h4>
  </div>
  <div class="white-box section-details">
    <p class="description">
      {{ 'steps.id5.account_to_fund.transfer_box.note' | translate }}
    </p>
  </div>
</div>
